import { messageFormat } from "./MessageId.slice";

const actions = messageFormat.actions;
export { actions as messageFormatActions };
